import styled from 'styled-components';

export const SidebarContainer = styled.div`
  width: 80px;
  height: 100vh;
  position: sticky;
  top: 0;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(48, 27, 114, 1);
  /* While the setup checklist (OnboardingComplete, fixed z-2000 takeover) is
     open, the sidebar must sit ABOVE it so the navbar stays visible with the
     Setup Progress item selected — same treatment as the mirror sidebar. */
  z-index: ${(props) => (props.isSetupCompleteOpen ? '2001' : '1000')};
  filter: ${(props) => (props.isBlurred ? 'blur(6px)' : 'none')};
  pointer-events: ${(props) => (props.isBlurred ? 'none' : 'auto')};
`;

export const SideBottom = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  cursor: pointer;

  p {
    font-family: var(--font-family-ibm_plex_sans);
    font-weight: 500;
    font-size: var(--font-size-s);
    line-height: 17px;
    color: rgba(216, 210, 250, 1);
  }
`;

export const SideBottomContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

export const SideBottomItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  opacity: ${props => props.disabled ? '0.5' : '1'};

  p {
    font-family: var(--font-family-ibm_plex_sans);
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${props => props.disabled ? 'rgba(216, 210, 250, 0.5)' : 'rgba(216, 210, 250, 1)'};
    margin: 0;
    text-align: center;
  }
`;

export const Logo = styled.img`
  display: block;
  margin: 0 auto 25px;
`;

export const SideNavbar = styled.div`
  /* Keep long navigation inside short viewports without scrolling the app. */
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 20px;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      text-align: center;
      cursor:auto;

      &.study-guide {
        .icon-wrapper img {
          width: 48px;
          height: 48px;
          object-fit: contain;
        }
      }

      
      &.locked {
        opacity: 1;
      }

      .icon-wrapper {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 8px;

        &.active-bg {
          background-color: rgba(251, 247, 254, 1);
        }

        img:not(.lock-badge) {
          width: 48px;
          height: 48px;
          display: block;
        }
      }

      .lock-badge {
        position: absolute;
        right: 3px;
        top: 3px;
        width: 16px;
        height: 16px;
        z-index: 1000;
        padding: 3px;
        background-color: #9E322B;
        border-radius: 50%;

        img {
          width: 12px;
          height: 12px;
        }
      }

      span {
        font-family: var(--font-family-ibm_plex_sans);
        line-height: 17px;
        color: rgba(216, 210, 250, 1);
        font-weight: 500;
        font-size: 13px;

        &.active {
          color: rgba(251, 247, 254, 1);
          font-weight: 600;
        }
      }
    }
  }
`;
